import React, { Suspense } from "react";
import dynamic from "next/dynamic";

const Card = dynamic(() => import("../../Blog/Card"), {
  suspense: true,
});

interface FeaturedProps {
  articles: any[];
}

const FeaturedArticles: React.FC<FeaturedProps> = ({ articles }) => {
  return (
    <div className="bg-gray-100">
      <div className="container mx-auto pt-5 pb-10 px-2">
        <div className="pb-5">
          <h2 className="text-2xl text-primary font-medium text-center md:text-left">
            Featured Articles
          </h2>
        </div>
        <hr />
        <div className="mt-2 px-1 md:px-0 grid overflow-hidden grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
          <Suspense
            fallback={
              <>
                <p>Loading...</p>
              </>
            }
          >
            {articles.map((item, index) => (
              <Card key={index} item={item} />
            ))}
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default FeaturedArticles;
